import $ from 'wee-dom';
import $events from 'wee-events';
import { RouteHandler } from 'wee-routes';
import { selected, disabled } from '../../scripts/classes';
import KeyHelper from '../../scripts/keyhelper';

class Action {
    constructor() {
        this.currentOptions = null;
        this.$parentFilter = $(':parentFilter');
        this.$childFilter = $(':childFilter');
        this.$filterButton = $(':filterButton');

        this.checkButtonToggles(this.$parentFilter);
        this.checkButtonToggles(this.$childFilter);
    }

    selectOption(el) {
        const $el = $(el);
        const translate = $el.index() * $el.height();

        $el.parent(':filter').css('transform', `translateY(-${translate}px`);

        $el.siblings().removeClass(selected);
        $el.addClass(selected);

        if ($el.data('type') === 'parent') {
            this.resetFilterStyles(this.$childFilter);
            this.filterOptions($el.data('value'));
            this.disableLink();
        } else if ($el.data('type') === 'child' && $el.data('value')) {
            this.setLink($el);
        }

        this.checkButtonToggles($el.parent());
        this.checkButtonToggles(this.$childFilter);
    }

    filterOptions(value) {
        const $options = $(`:${value}Options`);

        if (this.currentOptions) {
            $(`:${this.currentOptions}Options`).append($(`.js-filter .js-${this.currentOptions}`));
        }

        if (! value) {
            $(this.$childFilter.children()[0]).removeClass(selected);
        }

        this.$childFilter.append($options.children());
        this.currentOptions = value;
    }

    resetFilterStyles($el) {
        $el.css('transform', `translateY(0px)`);
        $el.children().removeClass(selected);
        $($el.children()[0]).addClass(selected);
    }

    setLink($el) {
        this.$filterButton.attr('href', $el.data('url'));
        this.$filterButton.removeClass(disabled);
        this.$filterButton.attr('tabindex', '0');
    }

    disableLink() {
        this.$filterButton.addClass(disabled);
        this.$filterButton.attr('tabindex', '-1');
    }

    setDisabled($el, value) {
        $el.disabled = value;
    }

    toggle(el, direction) {
        const $el = $(el).parent()
            .prev()
            .children(`.${selected}`)[direction]();

        if ($el.length) {
            this.selectOption($el);
        }
    }

    checkButtonToggles($el) {
        const $prev = $el.next().children(':controlUp');
        const $next = $el.next().children(':controlDown');

        if ($el.children().length !== 1) {
            $el.children().filter((i, el) => {
                const $el = $(el);

                if ($el.hasClass(selected)) {
                    if (! $el.prev().length) {
                        this.setDisabled($prev[0], true);
                        this.setDisabled($next[0], false);
                    } else if (! $el.next().length) {
                        this.setDisabled($prev[0], false);
                        this.setDisabled($next[0], true);
                    } else {
                        this.setDisabled($prev[0], false);
                        this.setDisabled($next[0], false);
                    }
                }
            });
        } else {
            this.setDisabled($prev[0], true);
            this.setDisabled($next[0], true);
        }
    }
}

export default new RouteHandler({
    init() {
        const action = new Action();

        $events.on({
            ':option': {
                click(e, el) {
                    action.selectOption(el);
                    e.preventDefault();
                },
            },
            ':filterControl': {
                keydown(e, el) {
                    const $controls = $(el).siblings(':buttonControls');

                    if (KeyHelper.isArrowUp(e)) {
                        action.toggle($controls.children(':controlUp')[0], 'prev');
                        e.preventDefault();
                    } else if (KeyHelper.isArrowDown(e)) {
                        action.toggle($controls.children(':controlDown')[0], 'next');
                        e.preventDefault();
                    }
                },
            },
            ':controlUp': {
                click(e, el) {
                    action.toggle(el, 'prev');
                    e.preventDefault();
                },
            },
            ':controlDown': {
                click(e, el) {
                    action.toggle(el, 'next');
                    e.preventDefault();
                },
            },
        });
    },
});
